<template>
  <div class="renderConfig">
    <div class="setting-view">
      <div
        v-if="editorIndex === null && !showHomeConfig"
        class="view-placeholder"
      >
        <i class="iconfont icon-shapes" />
        请选择左侧挂件
      </div>
      <!-- <div v-else-if="showHomeConfig">
        <HomeProps :show-home-config="showHomeConfig" />
        
      </div> -->
      <template v-else>
        <component
          :is="editorData.propsName"
          v-if="editorData.propsName"
          :key="editorData.id"
          :pedestal-config="pedestalConfig"
          :res="editorData"
          v-bind="targetProps"
          v-on="targetAction"
          @showPickerTmp="showPickerTmp"
        />
      </template>
    </div>
  </div>
</template>

<script>
// api
import register from '../../mixin/register'
import HomeProps from '@/view/weappTmp/comps/homeProps/index.vue'
import renderProps from '@/view/weappTmp/core/tmps/renderProps/index.vue'

// 第三方组件
export default {
  name: 'RenderConfig',
  components: {
    HomeProps,
    renderProps
  },
  mixins: [register],
  props: {
    _editor: {
      type: Object
    },
    showHomeConfig: {
      type: String
    },
    pedestalConfig: {
      type: Object
    }
  },
  data () {
    return {
      editorData: null,
      editorIndex: null,
      targetAction: {},
      targetProps: {}
    }
  },
  watch: {
    _editor: {
      handler (val) {
        // console.log('this.editorData1',val)
        this.editorData = val.editorData
        // console.log('this.editorData2',this.editorData)
        this.editorIndex = val.editorIndex
        this.targetAction = Object.assign(this.targetAction, this.$listeners)
        this.targetProps = Object.assign(this.targetProps, this.$attrs)
      },
      deep: true
    }
  },
  created () {},
  mounted () {
    
  },
  methods: {
    showPickerTmp (data) {
      this.$emit('showPickerTmp', data)
    }
  }
}
</script>

<style lang="scss">
@import '../../../index';
.renderConfig {
  min-width: 385px;
  width: 385px;
  // height: 675px;
  min-height: 695px;
  height: calc(100vh - 190px);
  background: #fff;
}
// @media screen and (min-width: 1600px) {
//   .renderConfig {
//     width: 400px;
//   }
// }
.setting-view {
  overflow: auto;
  height: 500px;
  .section-body {
    padding: 17px 24px;
  }
}
</style>
